import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import Spinner from 'components/ui/Spinner';
import { accessibilityParamsStore } from 'stores/root';

import s from './Loader.module.scss';

export type LoaderProps = {
  className?: string;
  mode?: 'relative' | 'absolute';
};

const Loader: React.FC<LoaderProps> = ({ className, mode = 'relative' }) => {
  const { isOpen: isAccessibilityMode } = accessibilityParamsStore;

  return (
    <span className={cn(s.root, s[`root_mode-${mode}`], isAccessibilityMode && s.root_accessibility, className)}>
      <Spinner />
    </span>
  );
};

export default observer(Loader);
